import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-mkt-modal2',
  templateUrl: './mkt-modal2.component.html',
  styleUrls: ['./mkt-modal2.component.scss'],
  standalone: false,
  host: { 'class': 'cbolui-cds' }
})
export class MktModal2Component {
  @Input() showModal = false;
  @Output() isOpen: EventEmitter<boolean | undefined> = new EventEmitter(undefined);

  openChange(isOpen) {
    this.isOpen.emit(isOpen)
  }
}
